import type { FilterGroup, SortOrder } from '@/contexts/products/ProductsContext'

export function getSortOrderIcon(sortOrderChosen: boolean, sortOrder: SortOrder) {
  if (!sortOrderChosen)
    return 'arrow-up-down'
  if (sortOrder === 'asc')
    return 'arrow-up'
  return 'arrow-down'
}

export function getActiveFiltersCount(filterGroups: FilterGroup[], searchParams: URLSearchParams) {
  let count = Number(searchParams.has('is_new')) + Number(searchParams.has('product_code'))

  for (const filterGroup of filterGroups) {
    const selectedFilterIds = searchParams.getAll(filterGroup.id)
    count += filterGroup.filters.filter(filter => selectedFilterIds.includes(filter.id)).length
  }

  return count
}
